import { Injectable } from '@angular/core';
import { IAuthService } from '../iauth.service';

import { AuthConfig } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserManager, UserManagerSettings, User } from 'oidc-client';

declare var virtualDirectory;
/* Left for reference
export const authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: 'https://login.microsoftonline.com/6ea74a44-2098-4a46-b4ce-a9e1ffda6fa8/v2.0/',
    tokenEndpoint: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_siupin',
    logoutUrl: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/logout?p=b2c_1_siupin',
    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '/APPlaybook/',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: '1f3eff9f-c174-4bf8-abe5-20462835d2c1',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid https://conquexenps.onmicrosoft.com/enpslocal/user_impersonation https://conquexenps.onmicrosoft.com/enpslocal/read',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1_siupin',
    requestAccessToken: true,
    responseType: "id_token" 
}*/

/*
export const authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '/APPlaybook/',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'f84aa838-cef4-4167-873d-42573c494736',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'https://graph.microsoft.com/user.read openid profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    //responseType: "id_token"
}

export const facebookAuthConfig: AuthConfig = {
    issuer: 'https://graph.facebook.com/me',
    loginUrl: 'https://www.facebook.com/dialog/oauth',
    tokenEndpoint: 'https://graph.facebook.com/oauth/access_token',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '192287021412038',
    scope: "email",
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true,
    oidc: false,
    requestAccessToken: true,
    responseType: "id_token"
}
*/

export const oktaAuthConfig: AuthConfig = {
    issuer: '',
    tokenEndpoint: '',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid email',
    strictDiscoveryDocumentValidation: false,
    loginUrl: '',
    requestAccessToken: false,
    responseType: "id_token"
}

export const microsoftAuthConfig: AuthConfig = {
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'User.Read email profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    responseType: "id_token"
}

export const googleAuthConfig: AuthConfig = {
    issuer: 'https://accounts.google.com',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    logoutUrl: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid profile email',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true
}

export const oneLoginAuthConfig: any = {
    authority: null,
    client_id: null,
    redirect_uri: window.location.origin + '/' + virtualDirectory,
    post_logout_redirect_uri: window.location.origin + '/' + virtualDirectory,
    response_type: 'id_token token',
    scope: 'openid profile',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: window.location.origin + '/' + virtualDirectory
};

@Injectable()
export class SSOService implements IAuthService {

    private oneLoginUserManager: UserManager = null;

    private googleId: string = 'GOOGLE';
    private microsoftId: string = 'MICROSOFT';
    private oktaId: string = 'OKTA';
    private oneLoginId: string = 'ONELOGIN';
    private authConfig: AuthConfig = null;
    private provider: string = '';
    public ssoSettings: Array<any> = null;

    private providerId: string = null;

    constructor(private oauthService: OAuthService) { }

    private async configureWithNewConfigApi() {
        if (this.ssoSettings) {
            for (let i = 0; i < this.ssoSettings.length; i++) {
                if (this.ssoSettings[i]["ID"] == "GOOGLE") googleAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "MICROSOFT LIVE" || this.ssoSettings[i]["ID"] == "MICROSOFTLIVE") microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "MICROSOFT AZURE" || this.ssoSettings[i]["ID"] == "MICROSOFTAZURE") microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "OKTA") {
                    oktaAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                    oktaAuthConfig.issuer = this.ssoSettings[i]["BaseUrl"];
                    oktaAuthConfig.tokenEndpoint = oktaAuthConfig.issuer + '/oauth2/v1/token';
                    oktaAuthConfig.loginUrl = oktaAuthConfig.issuer + '/oauth2/v1/authorize';
                }
                if (this.ssoSettings[i]["ID"] == "ONELOGIN") {
                    oneLoginAuthConfig.client_id = this.ssoSettings[i]["ClientId"];
                    oneLoginAuthConfig.authority = this.ssoSettings[i]["BaseUrl"] + '/oidc/2';
                    this.oneLoginUserManager = new UserManager(oneLoginAuthConfig);
                }
            }

            let providerId = localStorage.getItem("providerName");
            this.providerId = providerId;
            if (providerId == this.googleId) this.authConfig = googleAuthConfig;
            if (providerId.indexOf(this.microsoftId) > -1) this.authConfig = microsoftAuthConfig;
            if (providerId == this.oktaId) this.authConfig = oktaAuthConfig;
            this.oauthService.configure(this.authConfig);
            this.oauthService.tokenValidationHandler = new JwksValidationHandler();
            this.oauthService.setStorage(sessionStorage);
            if (providerId == this.googleId) {
                await this.oauthService.loadDiscoveryDocumentAndTryLogin();
            }
        }
    }

    public async authenticate() {
        await this.configureWithNewConfigApi();
        if (this.providerId == this.oneLoginId) {
            this.oneLoginUserManager.signinRedirect();
        } else {
            this.oauthService.initImplicitFlow();
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/authentication/sso/sso.service.ts